<template>
  <div id="kt_header" ref="kt_header" class="header bg-white header-fixed">
    <!--begin::Container-->
    <div class="d-flex align-items-stretch justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
      <!--begin::Left-->
      <div class="d-flex align-items-stretch mr-2">
        <div class="header-menu-wrapper header-menu-wrapper-left" ref="kt_header_menu_wrapper">
          <div v-if="true" id="kt_header_menu" ref="kt_header_menu" class="header-menu header-menu-mobile"
            v-bind:class="headerMenuClasses">
            <b-dropdown variant="light">
              <template v-slot:button-content>
                <span class="">
                  <i class="mr-2 fas fa-home"></i>{{ filialSelecionada }}
                </span>
              </template>
              <b-dropdown-item v-for="(filial, index) in lista_filiais_autorizadas" href="#" :key="index"
                @click="selectFilial(filial.id)">
                • {{ filial.filial }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper"
          ref="kt_header_menu_wrapper">
          <!--begin::Header Menu-->
          <div id="kt_header_menu" ref="kt_header_menu"
            class="header-menu header-menu-mobile header-menu-layout-default" v-bind:class="headerMenuClasses">
            <!--begin::Header Nav-->
            <KTMenu></KTMenu>
            <!--end::Header Nav-->
          </div>
          <!--end::Header Menu-->
        </div>
        <!--end::Header Menu Wrapper-->
      </div>
      <!--end::Left-->
      <!--begin::Topbar-->
      <KTTopbar></KTTopbar>
      <!--end::Topbar-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTMenu from "@/view/layout/header/Menu";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import KTTopbar from "@/view/layout/header/Topbar";

export default {
  name: "Header",
  components: {
    KTMenu,
    KTTopbar
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");

    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),
    lista_filiais_autorizadas() {
      return this.$store.state.sistema.lista_filiais_autorizadas;
    },

    filialSelecionada() {
      let filial_id = this.$store.state.sistema.id_filial_selecionada;
      if (!this.lista_filiais_autorizadas || !filial_id)
        return "Selecionar filial";
      return this.lista_filiais_autorizadas[filial_id]?.filial;
    },
    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if header container is fluid
     */
    widthFluid() {
      return this.layoutConfig("header.self.width") === "fluid";
    }
  },
  methods: {
    selectFilial(value) {
      this.$store.dispatch("sistema/setFilial", value);
      this.$store.dispatch("sistema/listar_permissoes_sede", value);
      window.location.reload();
    },
  },
};
</script>

<style scoped></style>
